// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"53":"profil","382":"tickets","553":"beschwerden","966":"login"}[chunkId] || chunkId) + "." + {"53":"9835b79c","382":"dc2c29b1","393":"239b128a","441":"973dbe60","553":"7371f1ad","789":"66287357","966":"3ff12cc5"}[chunkId] + ".js";
};